/**
 * Created by Ivan on 2026-05-04
 */

PersonalBest.DEFAULT_PER_DAY_SPEED.kingscup = {
    magicbottles: 5,
    tapaway: 5,
    arrows: 5,
    awaygames: 5,
    segmentsolitaire: 5,
    jigsol: 5,
    sheepaway: 5,
    bubbles: 5
};

PersonalBest.DEFAULT_PER_MINUTE_SPEED.lightning = {
    magicbottles: 0.5,
    meowdoku: 0.5,
    tapaway: 0.5,
    arrows: 0.5,
    awaygames: 0.5,
    segmentsolitaire: 0.5,
    jigsol: 0.5,
    sheepaway: 0.5,
    bubbles: 0.5
};

// Every aisensia game starts its bots from the same speed until its own statistics say otherwise,
// so a game that is not listed yet (a fresh scaffold) plays the common value instead of failing
// the competition start with "value not set" - list it above once it has numbers.
[[PersonalBest.DEFAULT_PER_DAY_SPEED.kingscup, 5], [PersonalBest.DEFAULT_PER_MINUTE_SPEED.lightning, 0.5]].forEach(([speeds, common]) => {
    if (speeds[cleverapps.config.type] === undefined) {
        speeds[cleverapps.config.type] = common;
    }
});
